import SharedSortableLists from './SharedSortableLists'
import AreaDirectorPublicationJobsIndex from './AreaDirectorPublicationJobsIndex'

export default class SortablePubJobsList extends SharedSortableLists {
  reactTableComponent() {
    return AreaDirectorPublicationJobsIndex;
  }

  defaultSortKey() {
    return "name"
  }

  sortData() {
    switch(this.sortKey) {
      case "name":
        return this.sortBy({attr: "publication_name"})
        break;
      case "status":
        return this.sortBy({attr: "nice_status"})
        break;
      case "date":
        return this.sortBy({attr: "date_modified"})
        break;
    }
  }
}
